import React from 'react';
import GoogleAuth from '../components/GoogleAuth';
import './AuthCard.css';

export default function Login() {
  const handleSuccess = (u, jwt) => window.location.href = '/onboarding';
  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h2>Entre na <span className="brand">Brazfy</span> e comece a ganhar</h2>
        <p>Não perca tempo, conecte com sua conta Google para começar a aproveitar nossa plataforma.</p>
        
        <div className="auth-actions">
          <GoogleAuth onSuccess={handleSuccess}/>
          <small>Criando uma conta, você concorda com nossos <a href="/termos">termos e condições</a>.</small>
        </div>
      </div>
    </div>
  );
}
